import { RoutePaths } from "../../common/RoutePaths";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { formatTimeRemainingInSecond } from "../../utils/timerService";

const PromoSpinnerBanner = ({ leftImage, rightImage, title }) => {
  const timeLeft = useSelector((state) => state?.spinner?.data?.nextDailySpinWheelInSeconds ?? 0);

  return (
    <Link to={RoutePaths.SPIN_WHEEL} className="flex items-center justify-between w-full px-1 pt-1 rounded-app bg-gradient-to-b from-[var(--pink-dark-shade)] to-[var(--pink-light-shade)] text-[var(--white-shade)]">
      {/* section 1 */}
      <div className="w-[20%]">
        <img src={leftImage} alt="left" className="w-full h-auto" />
      </div>

      {/* section 2 */}
      <div className="flex flex-col justify-center mx-auto">

        <div className="font-saira text-lg sm:text-2xl text-whiteShade font-bold leading-none tracking-normal align-middle">
          {timeLeft === 0 ? "Spin Now " : title}
        </div>
        {
          timeLeft !== 0 && (
            <div className="sm:mt-1 leading-[12px] text-[8.5px] sm:text-xs">
              <span className="align-middle font-medium text-[var(--pink-shade)]">
                Next Spin:
              </span>{" "}
              <span className="font-inter font-bold align-middle">
                {formatTimeRemainingInSecond(timeLeft)}
              </span>
            </div>
          )
        }

      </div>

      {/* section 3 */}
      <div className="w-[30%] mr-1 flex justify-end">
        <img src={rightImage} alt="right" className="w-full h-auto" />
      </div>
    </Link>
  );
};

export default PromoSpinnerBanner;
